export const BUTTON = 'button';
export const CHECKBOX = 'checkbox';
export const CUSTOM = 'custom';
export const ENABLED = 'enabled';
export const GROUP = 'group';
export const TEXT = 'text';
export const TOGGLE = 'toggle';
export const CUSTOMHEADER = 'customHeader';
export const CUSTOM_CELL = 'customCell';
export const RADIO_CELL = 'radioCell';
